export default function Testimonial() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="relative bg-foreground-950 rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            <div className="w-full lg:w-[38%] relative">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20stylish%20European%20woman%20with%20a%20confident%20smile%20wearing%20modern%20minimal%20fashion%20against%20a%20warm%20terracotta%20studio%20backdrop%20soft%20dramatic%20side%20lighting%20creating%20depth%20and%20dimension%20editorial%20quality%20clean%20composition%20magazine%20portrait%20style&width=600&height=800&seq=testimonial-portrait-v03&orientation=portrait"
                alt="Opinie użytkowników Kakobuy Spreadsheet"
                title="Kakobuy Spreadsheet - Opinie klientów"
                className="w-full h-full object-cover object-top min-h-[400px] lg:min-h-[600px]"
              />
            </div>

            <div className="w-full lg:w-[62%] flex flex-col justify-center px-8 md:px-14 py-12 md:py-16">
              <span className="text-7xl md:text-8xl font-heading text-accent-400 leading-none mb-2 select-none">&quot;</span>
              <blockquote className="text-white text-lg md:text-xl leading-relaxed max-w-xl mb-8 font-light">
                Kakobuy Spreadsheet zaoszczędził mi setki godzin szukania produktów. Najlepsza polska baza ofert z Chin — przejrzysta, zawsze aktualna i całkowicie darmowa. Polecam każdemu, kto szuka jakościowych produktów w rozsądnych cenach!
              </blockquote>
              <div className="mb-10">
                <p className="text-white font-semibold text-base">Anna K.</p>
                <p className="text-white/50 text-sm mt-1">Fashion Blogger, Warszawa</p>
              </div>
              <a
                href="#"
                className="inline-flex items-center px-6 py-3 rounded-full bg-accent-400/20 text-white text-sm font-medium hover:bg-accent-400/30 transition-colors cursor-pointer whitespace-nowrap w-fit"
              >
                Zobacz Więcej Opinii
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}